const EVENT_NAME = 'portal_click';

const track = (params = {}) => {
    if (typeof (AsgFW) !== 'undefined') {
        const eventPayload = {
            event: EVENT_NAME,
            platform: AsgFW.isMobilePamPlatform() ? 'Mobile web' : 'Desktop',
            regulation_type: AsgFW.getRegulation(),
            brand_id: AsgFW.getBrandID(),
            brand_name: AsgFW.getBrandName(),
            player_id: AsgFW.getPlayerID() || null,
            player_state: AsgFW.isLoggedIn() ? 'post login' : 'pre login',
            ...params,
        };

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(function() {
            this.reset();
        });
        window.dataLayer.push(eventPayload);
    }
};

export const GtmService = { track };
